import { render, staticRenderFns } from "./AllTerminations.vue?vue&type=template&id=4277f856&scoped=true&"
import script from "./AllTerminations.vue?vue&type=script&lang=js&"
export * from "./AllTerminations.vue?vue&type=script&lang=js&"
import style0 from "./AllTerminations.vue?vue&type=style&index=0&id=4277f856&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4277f856",
  null
  
)

export default component.exports